import React from 'react'

const WholeFolder = () => {
  return (
    <svg
      width="47"
      height="36"
      viewBox="0 0 47 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M37.3808 8.51184C37.3808 8.27221 37.3808 8.03134 37.3808 7.79171C37.3808 6.54614 36.8292 5.98825 35.5961 5.98825C30.0984 5.98825 24.6019 5.98451 19.1041 5.99574C18.7672 5.99574 18.5812 5.90463 18.414 5.60135C17.5653 4.06249 16.6742 2.54734 15.8292 1.00473C15.4411 0.298322 14.8969 -0.00370983 14.0907 3.43629e-05C10.0107 0.0175073 5.93081 0.00877082 1.85088 0.00877082C0.532924 0.00877082 0 0.535455 0 1.83719C0 4.06124 0 6.28654 0 8.51184V35.8882H37.3808V8.51184Z"
        fill="#C3C3C3"
      />
      <path
        d="M37.3158 9.12842H2.61581C1.87552 9.12842 1.27539 9.72855 1.27539 10.4688V34.5478C1.27539 35.2881 1.87552 35.8882 2.61581 35.8882H37.3158C38.0561 35.8882 38.6562 35.2881 38.6562 34.5478V10.4688C38.6562 9.72855 38.0561 9.12842 37.3158 9.12842Z"
        fill="#3249D7"
      />
      <path
        d="M46.8923 15.5269C44.823 21.9108 42.7325 28.2847 40.6445 34.6585C40.3824 35.4573 39.8819 35.8879 39.1431 35.8879H34.4266C24.6156 35.8891 14.8046 35.8879 4.99476 35.8879H0.278319C0.203435 35.8879 0.127303 35.8742 0 35.8629C0.330737 34.847 0.650242 33.8623 0.972243 32.8776C3.02906 26.5935 5.08836 20.3108 7.13519 14.0218H7.13644C7.13644 14.0218 7.13769 14.0155 7.13894 14.013C7.13894 14.013 7.13769 14.0118 7.13894 14.0105C7.15017 13.9781 7.1614 13.9456 7.17139 13.9132C7.28246 13.6586 7.73551 13.0408 9.50901 13.0396H9.51525C10.5212 13.0408 11.5271 13.042 12.5331 13.042C18.0121 13.0483 23.4911 13.0483 28.9714 13.0483C32.8416 13.0508 36.7119 13.0508 40.5821 13.0508H45.2985C46.2134 13.0508 46.8 13.4739 46.9622 14.3575C47.0296 14.7269 47.0072 15.1737 46.8923 15.5269Z"
        fill="#E1E1E1"
      />
    </svg>
  )
}

export default WholeFolder
